import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetAccountantSubscription } from '@assetaccountant/api/models/asset-accountant-subscription';
import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { PackageType } from '@assetaccountant/api/models/package-type';

const PRICE_ON_APPLICATION_PACKAGES = [
  PackageType.BusinessPremiumV2,
  PackageType.AccountingV2Premium,
];

@Component({
  selector: 'app-pricing-package-actions',
  templateUrl: './pricing-package-actions.component.html',
  styleUrls: ['./pricing-package-actions.component.scss'],
  standalone: false,
})
export class PricingPackageActionsComponent {
  @Input() subscription: AssetAccountantSubscription;
  @Input() packageType: PackageType;
  @Input() newOrganisation: boolean;
  @Input() isUpdating = false;

  @Output() updatePackage = new EventEmitter<PackageType>();

  readonly OrganisationPermissionType = OrganisationPermissionType;

  get actionLabel() {
    if (this.isCurrentPackage) {
      return 'Current Plan';
    }

    if (this.isPriceOnApplication) {
      return 'Price on Application';
    }

    return this.newOrganisation ? 'Start Now' : 'Change Plan';
  }

  get icon() {
    if (this.isCurrentPackage) {
      return 'check';
    }

    if (this.isPriceOnApplication) {
      return 'message-square';
    }

    return 'play';
  }

  get isPriceOnApplication() {
    return PRICE_ON_APPLICATION_PACKAGES.includes(this.packageType);
  }

  get isCurrentPackage() {
    return this.subscription?.packageType === this.packageType;
  }

  onUpdatePackage() {
    if (!this.isPriceOnApplication) {
      this.updatePackage.emit(this.packageType);
    }
  }
}
